var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountsImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38948 8.98403L6.45648 8.98403C4.42148 8.98403 2.77148 10.634 2.77148 12.669L2.77148 17.544C2.77148 19.578 4.42148 21.228 6.45648 21.228L17.5865 21.228C19.6215 21.228 21.2715 19.578 21.2715 17.544L21.2715 12.659C21.2715 10.63 19.6265 8.98403 17.5975 8.98403L16.6545 8.98403",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0215 2.19044L12.0215 14.2314",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10645 5.1189L12.0214 2.1909L14.9374 5.1189",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsImport);
export default __webpack_public_path__ + "static/media/AccountsImport.f76a680191106239340fb323499208ad.svg";
export { ForwardRef as ReactComponent };